exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transparent-black-bg-panel{background-color:rgba(0,0,0,.5);display:block;z-index:150;position:fixed;top:0;left:0;right:0;bottom:0}", ""]);

// exports
